import apiClient from "../apiClient";

export const AttendanceAPI = {
  createAttendance: ({
    attendanceType,
    remarks,
    deviceID,
    sourceType,
    fileAttached,
    location,
  }) =>
    apiClient.post("/api/v1/attendance", {
      AttendanceType: attendanceType,
      Remarks: remarks,
      DeviceID: deviceID,
      SourceType: sourceType,
      FileAttached: fileAttached,
      Location: location,
    }),

  getAllPaginated: ({ page, pageSize, filters }) => {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      ...filters,
    });

    return apiClient.get(`/api/v1/attendance?${params.toString()}`);
  },

  getLastAttendance: () =>
    apiClient.get("/api/v1/attendance/latest-attendance"),

  createOfficialBusiness: ({
    obDateFrom,
    obDateTo,
    obTimeFrom,
    obTimeTo,
    reason,
    mediaID,
  }) =>
    apiClient.post("/api/v1/attendance/official-business", {
      OBDateFrom: obDateFrom,
      OBDateTo: obDateTo,
      OBTimeFrom: obTimeFrom,
      OBTimeTo: obTimeTo,
      Reason: reason,
      MediaID: mediaID,
    }),

  getAllOBPaginated: ({ page, pageSize, filters }) => {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters || {}).filter(([_, value]) => value !== null)
    );

    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      ...cleanFilters,
    });

    return apiClient.get(
      `/api/v1/attendance/official-business?${params.toString()}`
    );
  },
};
